import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import '../assets/css/wordmatch.css';
import Sidebar from '../components/Sidebar';
import GameMenu from '../components/GameMenu';
import Timer from '../components/Timer';

export default function WordMatch() {
  const [timerIsFinished, setTimerIsFinished] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);

  const sendTime = (time) => {
    setTimeElapsed(time);
  };

    const wordPairs = [
        { en: "cat", fr: "chat",  syn: "feline", ant: "dog" },
        { en: "dog", fr: "chien",  syn: "canine", ant: "cat"},
        { en: "house", fr: "maison",  syn: "home", ant: "street"},
        { en: "book", fr: "livre",  syn: "volume", ant: "magazine"},
        { en: "apple", fr: "pomme",  syn: "fruit", ant: "meat" },
    ];
      
    function shuffle(array) {
        return [...array].sort(() => Math.random() - 0.5);
    }

    const [enWords, setEnWords] = useState([]);
    const [otherWords, setOtherWords] = useState([]); // fr ou syn
    const [otherColumnKey, setOtherColumnKey] = useState("");
    const [selected, setSelected] = useState({ lang: null, word: null });
    const [matched, setMatched] = useState([]);
    const [feedback, setFeedback] = useState([]);
    const [errorCount, setErrorCount] = useState(0);

    const [useSynonyms, setUseSynonyms] = useState(false);

    useEffect(() => {
      const sample = wordPairs[0];
      const keys = Object.keys(sample).filter((k) => k !== "en");
      const chosenKey = keys[Math.floor(Math.random() * keys.length)];
      setOtherColumnKey(chosenKey);

      const useSyns = Math.random() < 0.5;
      setUseSynonyms(useSyns);

      const en = wordPairs.map((pair) => ({
        value: pair.en,
        key: pair.en,
      }));

      // const other = wordPairs.map((pair) => ({
      //   value: useSyns ? pair.syn : pair.fr,
      //   key: pair.en,
      // }));
      const other = wordPairs.map((pair) => ({
        value: pair[chosenKey],
        key: pair.en,
      }));

      setEnWords(shuffle(en));
      setOtherWords(shuffle(other));
    }, []);

    const isMatched = (word) =>
      matched.some(p => p.en === word || p.other === word);

    const isInFeedback = (word) => {
      const item = feedback.find(p => p.en === word || p.other === word);
      return item ? item.success ? "success" : "error" : null;
    };

    const handleSelect = (word, lang, key) => {
      if (isMatched(word)) return;

      if (!selected.word) {
        setSelected({ word, lang, key });
      } else if (selected.lang === lang) {
        setSelected({ word, lang, key }); // même colonne → remplace la sélection
      } else {
        const pair =
          lang === "en"
            ? { en: word, other: selected.word, leftKey: key, rigthKey: selected.key }
            : { en: selected.word, other: word, leftKey: selected.key, rightKey: key };

        // const isCorrect = wordPairs.some((pairData) => {
        //   return (
        //     pairData.en === pair.en &&
        //     (useSynonyms ? pairData.syn === pair.other : pairData.fr === pair.other)
        //   );
        // });

        // const isCorrect = wordPairs.some((pairData) => {
        //   return (
        //     pairData.en === pair.en &&
        //     pairData[otherColumnKey] === pair.other
        //   );
        // });

        const isCorrect = pair.leftKey === pair.rightKey;

        if (isCorrect) {
          setMatched([...matched, pair]);
          setFeedback([...feedback, { ...pair, success: true }]);
          setTimeout(() => {
            setFeedback((f) =>
              f.filter((p) => p.en !== pair.en && p.other !== pair.other)
            );
          }, 1000);
        } else {
          setErrorCount((prev) => prev + 1);
          setFeedback([...feedback, { ...pair, success: false }]);
          setTimeout(() => {
            setFeedback((f) =>
              f.filter((p) => p.en !== pair.en && p.other !== pair.other)
            );
          }, 1000);
        }

        // setSelected({ lang: null, word: null });
        setSelected({ word: null, lang: null, key: null });
      }
    };

    const getButtonStyle = (word, lang) => {
      if (isMatched(word)) return {  backgroundColor: "var(--orange)", borderColor: "var(--orange)", color: "white" };

      if (selected.word === word && selected.lang === lang) {
        return { borderColor: "var(--orange)", color: "var(--orange)" }; // light blue
      }

      const state = isInFeedback(word);
      if (state === "success") return { backgroundColor: "var(--orange)", borderColor: "var(--orange)", color: "white" };
      if (state === "error") return { backgroundColor: "#A8AEBE", color: "white" }; // light red

      return {};
    };

    const location = useLocation();
    const { theme, subTheme } = location.state || {};

    return (
        <div className="page-container">
            <Sidebar />

            <div className="content-container inGame" id="wordMatch">
                <div class="title">
                    <h4>{theme} - {subTheme} </h4>
                    <div class="level-infos">
                        <p> Niveau ??</p>
                        <Timer timer={timerIsFinished} onFinish={() => setTimerIsFinished(true)} onSendTime={sendTime} />
                    </div>
                </div>

                <div className="game-container launched">
                  <h3>Associez chaque mot à sa traduction et à sa définition</h3>
                  <div className="columns-container">
                    <div className="column-type">
                      <h3>Anglais</h3>
                      <div className="words-container">
                        {enWords.map((item) => (
                          <div
                            key={item.value}
                            className="words"
                            style={{ ...getButtonStyle(item.value, "en") }}
                            onClick={() => handleSelect(item.value, "en", item.key)}
                            disabled={isMatched(item.value)}
                          >
                            {item.value}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="column-type">
                      <h3>({otherColumnKey})</h3>
                      <div className="words-container">
                        {otherWords.map((item) => (
                          <div
                            key={item.value}
                            className="words"
                            style={{ ...getButtonStyle(item.value, "other") }}
                            onClick={() => handleSelect(item.value, "other", item.key)}
                            disabled={isMatched(item.value)}
                          >
                            {item.value}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Liste des paires trouvées */}
                  {/* <div className="correct-answers">
                    <h3>Mots trouvés</h3>
                    {matched.length === 0 && <p>Aucune paire trouvée pour l'instant.</p>}
                    <ul style={{ listStyle: "none", padding: 0 }}>
                      {matched.map((pair, index) => (
                        <li key={index} style={{ margin: "5px 0", color: "green", fontWeight: "bold" }}>
                          {pair.en} — {pair.other}
                        </li>
                      ))}
                    </ul>
                  </div> */}

                  <div className="wrong-answers">
                      <h2>Erreurs : {errorCount}</h2>
                  </div>
                </div>

            </div>
            <GameMenu />
        </div>
    )
}